/**
 * API base URL for backend requests.
 * - Local dev: http://localhost:8000/api
 * - Production: Fly.io directly (CORS configured on backend)
 * - Override: REACT_APP_BACKEND_URL=https://your-app.fly.dev
 */
const DEFAULT_FLY_BACKEND = "https://backend-lingering-star-8279.fly.dev";

function resolveApiBase() {
  const configured = process.env.REACT_APP_BACKEND_URL?.trim().replace(/\/$/, "");

  if (configured) {
    if (process.env.NODE_ENV === "production" && /localhost|127\.0\.0\.1/.test(configured)) {
      return `${DEFAULT_FLY_BACKEND}/api`;
    }
    return configured.endsWith("/api") ? configured : `${configured}/api`;
  }

  if (process.env.NODE_ENV === "development") {
    return "http://localhost:8000/api";
  }

  return `${DEFAULT_FLY_BACKEND}/api`;
}

export const API_BASE = resolveApiBase();
